import { useParams } from 'react-router-dom'
import {
    ServiceSLAConfig,
    DowntimeList,
} from '@/modules/Service/components/SLA'

const SLA = () => {
    const { id: serviceID } = useParams()

    return (
        <div className="space-y-2">
            <ServiceSLAConfig serviceId={Number(serviceID)} />
            <DowntimeList serviceId={Number(serviceID)} />
        </div>
    )
}

export default SLA
